import React from 'react';
import useAudioPlayback, { formatAudioTime } from '../../hooks/useAudioPlayback';
import AudioWaveformCanvas from './AudioWaveformCanvas';

interface AudioPlaybackControlsProps {
	src: string;
	activeColor?: string;
	inactiveColor?: string;
	progressLineColor?: string;
	iconColor?: string;
	className?: string;
}

const AudioPlaybackControls: React.FC<AudioPlaybackControlsProps> = ({
	src,
	activeColor = '#ff6b35',
	inactiveColor = '#9ca3af',
	progressLineColor,
	iconColor = '#000',
	className,
}) => {
	const playback = useAudioPlayback({ src: src });

	return (
		<div
			className={
				'flex min-w-0 items-center gap-2 rounded-xl py-2' + (className ? ' ' + className : '')
			}
		>
			<button
				onClick={playback.togglePlayPause}
				className="flex h-8 w-8 flex-shrink-0 cursor-pointer items-center justify-center border-none bg-transparent p-0 outline-none"
				type="button"
			>
				{playback.isPlaying ? (
					<i
						style={{ fontSize: 24, color: iconColor }}
						className="icons8-font icons8-pause-filled"
					/>
				) : (
					<i style={{ fontSize: 24, color: iconColor }} className="icons8-font icons8-play-2" />
				)}
			</button>

			<div className="relative h-10 min-w-0 flex-1">
				{playback.isLoading ? (
					<div className="flex h-full items-center justify-center text-gray-400">Loading...</div>
				) : (
					<AudioWaveformCanvas
						waveformData={playback.waveformData}
						progress={playback.progress}
						onClick={playback.seek}
						activeColor={activeColor}
						inactiveColor={inactiveColor}
						progressLineColor={progressLineColor}
					/>
				)}
			</div>

			<div className="min-w-[35px] flex-shrink-0 text-right text-xs text-gray-400">
				{formatAudioTime(playback.duration)}
			</div>
		</div>
	);
};

export default AudioPlaybackControls;
